<template>
  <v-app id="app">
    <NavigationDrawer ref="navigationDrawer" />
    <v-main id="main-content">
      <!-- <v-btn
        class="ml-4 my-4"
        @click="changeLocale()">
        Language : {{ $i18n.locale }}
      </v-btn> -->
      <!-- {{ themeData.theme }} -->

      <v-fade-transition mode="out-in">
        <router-view class="content" />
      </v-fade-transition>
      <Loading />
    </v-main>
  </v-app>
</template>

<script>
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import Loading from '@/components/Loading.vue'
import DataClinicProvider from '@/resources/DataClinicProvider'
import ThemeProvider from '@/resources/ThemeProvider'

const ThemeService = new ThemeProvider()
const DataClinicService = new DataClinicProvider()
export default {
  name: 'DefaultLayout',
  components: {
    NavigationDrawer,
    Loading
  },
  data () {
    return {
    }
  },
  computed: {
    branchData () {
      return this.$store.getters['Branch/branch']
    },
    themeData () {
      return this.$store.getters['Clinic/clinic']
    }
  },
  async beforeMount () {
    if (this.themeData.userId) {
      this.getDataClinicByid()
      await this.getColors()
      this.setThemeColor()
    }
  },
  methods: {
    setThemeColor () {
      this.$vuetify.theme.themes.light.menu = this.themeData.theme.colorMenu
      this.$vuetify.theme.themes.light.primary = this.themeData.theme.colorMain
      this.$vuetify.theme.themes.light.second = this.themeData.theme.colorSecond
    },
    async getColors () {
      try {
        this.$store.dispatch('Loading/addLoading')
        const { data } = await ThemeService.getColors()
        this.$store.dispatch('Clinic/setTheme', {
          colorMenu: data[0].colorMenu,
          colorMain: data[0].colorMain,
          colorSecond: data[0].colorSecond
        })
      } catch (error) {
        console.error('[ERROR] changeColor', error?.message)
        this.$notify.error(error?.message)
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    },
    async getDataClinicByid () {
      try {
        this.$store.dispatch('Loading/addLoading')
        const { data } = await DataClinicService.getDataClinicByid(this.branchData.branchId)
        this.$store.dispatch('Clinic/setClinicAddress', { ...data.address })
      } catch (error) {
        console.error('[ERROR] getDataClinicByid', error?.message)
        this.$notify.error(error?.message)
      } finally {
        this.$store.dispatch('Loading/removeLoading')
      }
    },
    changeLocale () {
      if (this.$i18n.locale === 'en') {
        this.$i18n.locale = 'th'
      } else {
        this.$i18n.locale = 'en'
      }
    },
    triggerChild () {
      const child = this.$refs.navigationDrawer
      child.getDataReadApi()
    }
  }
}
</script>

<style lang="scss">
.v-dialog{
overflow-y: unset !important;
}
.btnlinear{
  background: linear-gradient(135deg, #0E153A 0%, #219DAB 100%);
}

#main-content{
  :deep(.v-input__slot){
  background: #FFFFFF;
}
}

.content {
  padding: 15px;
}

// #app{
//   font-family: 'Prompt';
//   font-style: normal;
//   font-size: 14px;
// }
// <------ css v-tab ------>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th{
  color: #FFFFFF;
}
.v-tab--active{
background: #195c76;
}
.v-tabs-slider-wrapper{
z-index: 0 !important;
}
.v-slide-group__content.v-tabs-bar__content{
background: #EEFAFC;
}
// <------ css data-table ------>

// .v-data-table__wrapper{
//   border-radius: 10px;
// }
</style>
